class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    if (!this.hasHover()) return;
    if (event.detail === 0) return;
    const href = event.currentTarget.dataset.href;
    if (!href || href === '#') return;
    event.preventDefault();
    window.location.href = href;
  }

  hasHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  onMouseEnter() {
    if (!this.hasHover()) return;
    clearTimeout(this.closeTimer);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      clearTimeout(menu.closeTimer);
      if (menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')) {
        menu.close();
      }
    });
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    if (!this.hasHover()) return;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
